export const WorkLifeBalanceEnum = Object.freeze({
  Excellent: 0, // Within ±5%
  Acceptable: 1, // Within ±10%
  Poor: 2, // Below −10% (Underworked)
  Overworked: 3,
});

export const WorkLifeBalanceLabel = Object.freeze({
  [WorkLifeBalanceEnum.Excellent]: "Excellent",
  [WorkLifeBalanceEnum.Acceptable]: "Acceptable",
  [WorkLifeBalanceEnum.Poor]: "Poor",
  [WorkLifeBalanceEnum.Overworked]: "Overworked",
});
